import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { ReactComponent as GiftIcon } from '../../assets/images/gift.svg';
import { Spacer, Subtitle, Title } from '../../components/common';
import { IonButton, IonIcon } from '@ionic/react';
import { chevronForward } from 'ionicons/icons';
import { setCommonProp } from '../../store/actions';

class ApplyLoyalty extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { __ } = this.props;

		return (
			<div className='large-padding grid-wrapper grid-align-start grid-justify-center text-centered'>
				<div className='icon-wrapper'>
					<GiftIcon />
				</div>
				<Spacer size={4} />
				<Title>{__('Earn loyalty')}</Title>
				<Spacer size={1} />
				<Subtitle className='text-color'>{__('Earn rewards and redeem your points or vouchers. ')}</Subtitle>
				<Spacer size={4} />
				<IonButton
					onClick={() => {
						this.props.dispatch(setCommonProp('applyLoyaltyModalOpen', false))
						this.props.dispatch(setCommonProp('loginModalOpen', true))
					}}
					className='large-button'>{__('Login')}
					<IonIcon slot='end' icon={chevronForward} />
				</IonButton>
				<Spacer size={1} />
				<IonButton
					onClick={() => this.props.dispatch(setCommonProp('applyLoyaltyModalOpen', false))}
					color={'secondary'} className='large-button'>{'Continue as guest'}</IonButton>
			</div>
		);
	}
}

const stateToProps = (state) => {
	return {
		transactionHistory: state.orders.history || [],
		orderHistory: state.orders.orderHistory || [],
		profile: state.profile.profile,
	};
};

export default withRouter(withTranslation(connect(stateToProps)(ApplyLoyalty)));
